import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Card, Button, Collapse, Switch, InputNumber, Layout, Tooltip } from "antd";
import {
    CheckOutlined,
    TagFilled,
    FireOutlined,
    UpOutlined,
    DownOutlined,
    ArrowRightOutlined,
} from "@ant-design/icons";
import "./FeaturedInArticles.scss";

const { Content } = Layout;
const { Paragraph } = Typography;

const featured_in = [
    {
        width: "122px",
        name: "GRITDAILY",
        logo: "/featured/gritdaily.png",
        press_link:
            "https://gritdaily.com/all3d-transforming-retail-virtualization-and-3d/",
    },
    {
        width: "160px",
        name: "House Beautiful",
        logo: "/featured/house_beautiful.png",
        press_link:
            "https://www.housebeautiful.com/room-decorating/bedrooms/a60200267/pattern-on-pattern-trend/",
    },
    {
        width: "49px",
        name: "Architectural Digest",
        logo: "/featured/ad.png",
        press_link:
            "https://www.architecturaldigest.com/story/whats-the-right-digital-rendering-solution-for-you",
    },
    {
        width: "121px",
        name: "Apartment Therapy",
        logo: "/featured/apartment.png",
        press_link:
            "https://www.apartmenttherapy.com/john-robshaw-for-cloth-and-company-36991626",
    },
    {
        width: "87px",
        name: "Yahoo Finance",
        logo: "/featured/yahoo.png",
        press_link:
            "https://finance.yahoo.com/news/all3d-certified-amazon-partner-empowers-133000644.html",
    },
    {
        width: "137px",
        name: "Veranda",
        logo: "/featured/veranda.png",
        press_link:
            "https://www.veranda.com/home-decorators/design-trends/a61950215/what-is-a-night-room-design/",
    },
];
const FeaturedInArticles = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    )
}

const WebVersion = () => {
    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid featured-in-wrapper">
                <Col span={15} className="direction-flex coll justify-in-center">
                    <div className="manrope f-20 w-500 lh-28 mb-32 white text-center">
                        Featured in
                    </div>
                </Col>
                <Col span={24} className="justify-in-center article-section">
                    {featured_in.map((article) => (
                        <Tooltip title={<span className="manrope f-12 white">{article.name}</span>}>
                            <a href={article.press_link} target="_blank">
                                <img className="article-img" src={article.logo} width={article.width}
                                />
                            </a>
                        </Tooltip>
                    ))}

                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid featured-in-wrapper">
                <Col span={24} className="direction-flex coll justify-in-center">
                    <div className="manrope f-16 w-700 lh-24 mb-24 white text-center">
                        Featured in
                    </div>
                </Col>
                <Col span={24} className="justify-in-center slider-track">
                    <div className="article-section slider-inner">
                        {[...featured_in, ...featured_in, ...featured_in].map((article) => (
                            <Tooltip title={<span className="manrope f-12 white">{article.name}</span>}>
                                <a href={article.press_link} target="_blank">
                                    <img className="article-img" src={article.logo} width={article.width}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                    </div>
                </Col>
            </Row>
        </Content>
    );
}

export default FeaturedInArticles;
